export default __webpack_public_path__ + "static/media/wip.aedc078c.svg";